import 'array.prototype.fill';
import React from 'react';
import { PropTypes as RPT } from 'prop-types';

import { Link } from 'react-scroll';

const LEVELS = new Array(4).fill().map((_, i) => i + 1);

const Bricks = ({
  handleQuestionClick,
  height,
  label,
  link,
  rowIndex,
  scrollOffset,
}) => (
  <div className="graph__row">
    <Link
      className="graph__row-label-wrapper"
      to={link}
      smooth
      offset={scrollOffset * -1}
      onClick={handleQuestionClick(link)}
      duration={750}
    >
      <span className="graph__row-label-index">{rowIndex}</span>
      <span className="graph__row-label">{label}</span>
    </Link>
    {LEVELS.map((level, i) => (
      <div key={level} className="graph__level">
        {rowIndex === 1 && <span className="graph__level-label">level {level}</span>}
        {i === 0 && <div className="graph__bar" style={{ width: `${height * 100}%` }} />}
      </div>
    ))}
  </div>
);

Bricks.propTypes = {
  handleQuestionClick: RPT.func.isRequired,
  height: RPT.number.isRequired,
  label: RPT.string.isRequired,
  link: RPT.string.isRequired,
  rowIndex: RPT.number.isRequired,
  scrollOffset: RPT.number.isRequired,
};

export default Bricks;
